const PDF = 'pdf'
const WORD_DOC = 'wordDoc'
const POWERPOINT = 'powerpoint'

export const fileTypes = [PDF, WORD_DOC, POWERPOINT]
